import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AUTH_SERVER_URL, OFFER_SERVER_URL, ORDER_SERVER_URL } from '../../config';
import {
	AudienceResponse, DmtFeasibilityRequest, DmtFeasibilityResponse,
	EfeasibilityInfo, SteelGrade
} from '../models/efeasibility';
import { OrderBy } from '../../shared/utils/constant';
import { PaginatedResult } from '../../shared/models/paginated-result';

const POST_EFEASIBILITY_URL = `${ ORDER_SERVER_URL }/v1/efeasibility`;
const AUTH_GET_AUDIENCES = `${ AUTH_SERVER_URL }/v1/user-management/audiences:external`;
const OFFER_GET_FEASIBILITY = `${ OFFER_SERVER_URL }/v1/efeasibility`;

@Injectable({ providedIn: 'root' })
export class EfeasibilityService {
	constructor(
		private readonly http: HttpClient
	) {}

	async addEfeasibility(requestData: EfeasibilityInfo[]) {
		const url = POST_EFEASIBILITY_URL;
		await firstValueFrom(this.http.post(url, requestData));
	}

	getAudiences(
		fields: string[],
		filter: string | undefined,
		page: number,
		limit: number,
		orderBy: OrderBy<keyof AudienceResponse>[] | OrderBy<keyof AudienceResponse>
	) {
		const url = new URL(AUTH_GET_AUDIENCES);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(page));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));
		return this.http.get<PaginatedResult<AudienceResponse>>(url.toString());
	}

	async getSteelgrades(soldTo: string, subCategory: string) {
		const url = new URL(`${ OFFER_GET_FEASIBILITY }/steelgrades`);
		const params = url.searchParams;
		params.append('soldTo', soldTo);
		params.append('subCategory', subCategory);
		const response = firstValueFrom(this.http.get<SteelGrade[]>(url.toString()));

		const steelgrades: Record<string, string[]> = {};
		const standardSteelgrades: string[] = [];

		for (const steelGradeItem of await response) {
			const names: string[] = Array.isArray(steelGradeItem.steelGradeNames)
				? steelGradeItem.steelGradeNames
				: [steelGradeItem.steelGradeNames];
			standardSteelgrades.push(steelGradeItem.steelGradeStandardName);
			steelgrades[steelGradeItem.steelGradeStandardName] = Array.from(new Set([
				...steelgrades[steelGradeItem.steelGradeStandardName] ?? [],
				...names
			]));
		}
		return { steelgrades, standardSteelgrades };
	}

	getDmtFeasibility(dmtFeasibilityRequest: DmtFeasibilityRequest) {
		const url = new URL(`${ OFFER_GET_FEASIBILITY }/dmtFeasibility`);
		return this.http.post<DmtFeasibilityResponse>(
			url.toString(),
			dmtFeasibilityRequest
		);
	}
}
